import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { BackListButton, OutOfPolicyChip, Text } from '@reveni-io/reveni-ui'

import routes from '@/Router/routes.constants'

import * as Styles from './styles'

const Header = ({ orderName, orderOutOfPolicy }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.MainContainer>
      <div>
        <BackListButton to={routes.transactionsPage}>{t('Listado de transacciones')}</BackListButton>
      </div>
      <Styles.TitleContainer>
        <Text type="titleL" color={theme.colors.outline.default}>
          {orderName}
        </Text>
        {orderOutOfPolicy && <OutOfPolicyChip />}
      </Styles.TitleContainer>
    </Styles.MainContainer>
  )
}

export default Header
